export function createTag(tagName, _option) {
   var option = _option || {};
   var tag = document.createElement(tagName);
   Object.keys(option).forEach(function (key) {
      tag.setAttribute(key, option[key]);
   });
   return tag;
}
export function openURL(url, _target, _data, _requestMethod) {
   var target = _target || "_self";
   var data = _data || {};
   var requestMethod = _requestMethod || "POST";
   if (Object.keys(data).length == 0) {
      window.open(url, target);
      return;
   }

   var thisForm = document.createElement("form");
   thisForm.method = requestMethod;
   thisForm.action = url;
   thisForm.target = target;

   Object.keys(data).map(function (key) {
      var input_field = document.createElement("input");
      input_field.type = "hidden";
      input_field.name = key;
      input_field.value = data[key];
      thisForm.appendChild(input_field);
   });

   document.body.appendChild(thisForm);
   if (
      ["_blank", "_self", "_parent", "_top"].indexOf(target) == -1 &&
      Boolean(document.getElementById(target)) == false
   ) {
      window.open("", target);
   }

   thisForm.submit();
   document.body.removeChild(thisForm);
}
export function getSession(key, defaultValue){
   if (typeof (Storage) !== "undefined") {
      return sessionStorage.getItem(key);
   }else{
      return defaultValue;
   }
}
export function setSession(key, value){
   if (typeof (Storage) !== "undefined"){
      sessionStorage.setItem(key, value);
   } 
}